// extracted by mini-css-extract-plugin
export default {"img":"background-item-fill-item-module__img--I63_w"};